import { Box, TableCell, TableRow } from '@material-ui/core';
import { formatDateTimeReadable } from '@nemuru-eng/js-api-client';

import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { SizedIconWithCircle } from '@/components/shared/components/SizedIconWithCircle';
import { useCustomTheme } from '@/hooks/useCustomTheme';

import { PasswordRecovery } from './PasswordRecoveryListTableBody';

interface PasswordRecoveryListTableRowProps {
  passwordRecoveryProps: PasswordRecovery;
  className: string;
}

export const PasswordRecoveryListTableRow = ({
  passwordRecoveryProps,
  className,
}: PasswordRecoveryListTableRowProps) => {
  const { palette } = useCustomTheme();

  return (
    <TableRow key={passwordRecoveryProps.id} className={className}>
      <TableCell align={'left'}>
        <Box p={1} display={'flex'} alignItems={'center'} justifyContent={'center'}>
          <SizedIconWithCircle
            variant={'small'}
            backgroundColor={palette.secondary.light}
            iconColor={palette.secondary.contrastText}
            customBorderRadius={100}
            iconName={passwordRecoveryProps.hasBeenUsed ? 'drafts' : 'email'}
            copyToClipboard={{
              value: passwordRecoveryProps.id,
              textId: 'COPY_EMAIL_ID',
            }}
          />
        </Box>
      </TableCell>
      <TableCell align={'center'}>
        <Font variant={'body2'} color={'textPrimary'}>
          {formatDateTimeReadable(passwordRecoveryProps.createdAt)}
        </Font>
      </TableCell>
      <TableCell align={'center'}>
        <Font variant={'body2'} color={'textPrimary'}>
          {formatDateTimeReadable(passwordRecoveryProps.expirationDate)}
        </Font>
      </TableCell>
      <TableCell align={'center'} style={{ verticalAlign: 'middle', justifyContent: 'center', alignItems: 'center' }}>
        {passwordRecoveryProps.canBeUsedToChangePassword ? (
          <Icon color={palette.success.main}>check</Icon>
        ) : (
          <Icon color={palette.error.main}>close</Icon>
        )}
      </TableCell>
      <TableCell align={'center'} style={{ verticalAlign: 'middle', justifyContent: 'center', alignItems: 'center' }}>
        {passwordRecoveryProps.hasBeenUsed ? (
          <Icon color={palette.success.main}>check</Icon>
        ) : (
          <Icon color={palette.error.main}>close</Icon>
        )}
      </TableCell>
    </TableRow>
  );
};
